<div
  class="counter-input-wrapper"
  [ngClass]="{'locked': readonly}"
>

  @if (!value && !zeroIsValid) {

    <yu-button
      color="info"
      size="small"
      (yuClick)="doAction(onlyNegative ? -1 : 1)"
    >
      {{ addText | translate }}
    </yu-button>

  } @else {

    <div
      class="counter-wrapper"
      [ngClass]="{'only-negative': onlyNegative}"
    >

      <yu-button
        color="info"
        size="small"
        (yuClick)="doAction(-1)"
      >
        <yu-icon name="minus" color="light"></yu-icon>
      </yu-button>

      <div class="number" (click)="doAction()">
        {{ (value || 0) | number: '1.0-2' }}
      </div>

      <yu-button
        color="info"
        size="small"
        (yuClick)="doAction(1)"
      >
        <yu-icon name="plus" color="light"></yu-icon>
      </yu-button>

    </div>

  }

</div>
